import {
  TAGS_REQUEST,
  TAGS_SUCCESS,
  TAGS_FAILURE,
  ADD_TAG
} from './tag-actions';

// Initial AuthReducer State
const initialState = {
  isFetching: false,
  tags: {
    farm: [],
    field: [],
    treatment: []
  }
};

// Auth Reducer
function tagsReducer(state = {...initialState}, action) {
  
  switch (action.type) {
    case TAGS_REQUEST:

      return { ...state, isFetching: true };
    case TAGS_SUCCESS: {
      const tags = { ...initialState.tags };
      action.tags.forEach(tag => {
        if(tag.value) {
          if(tags[tag.tag_type.toLowerCase()].includes(tag.value) === false) {
            tags[tag.tag_type.toLowerCase()].push(tag.value);
          }
        }
      });
      return { ...state, isFetching: false, tags };
    }
    case TAGS_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.error };
    case ADD_TAG: {

      const { tag, tagType } = action;
      const tags = { ...state.tags };
      if (tag && tagType) {
        let doesExist = tags[tagType].includes(tag);
        if (!doesExist) tags[tagType].push(tag);
      }
      return { ...state, tags };
    }
    default: {
      return state;
    }
  }
}

export default tagsReducer;

export function getAccountTags(store) {
  return store.entities.tags.tags;
}
